import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1825">
      <Hero data-id="element-1826" />
      <WhyUs data-id="element-1827" />
      <Services data-id="element-1828" />
      <HowItWorks data-id="element-1829" />
      <FAQ data-id="element-1830" />
      <Reviews data-id="element-1831" />
      <CtaBanner data-id="element-1832" />
    </main>;
}